import styled from '@emotion/styled'
import {theme} from '../../../../../core/theme'

export const CatalogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: ${theme.palette.neutral[0]};
  border-radius: 12px;
  // border: 1px solid #cedcf9;
  height: 100%;
  overflow: hidden;
`

export const ProductsPanel = styled.div`
  min-width: 0;
  width: 100%;
  background: ${theme.colors.bg.primary};
  border-radius: ${theme.radii.lg2};
  padding: ${theme.space[2.5]};
  position: relative;
`

export const CatalogLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.radii.lg2};
`

// Header/BrandSection/LogoMark/TitleGroup/Title/Subtitle/Actions mirror
// ProposalTool's ProductsCatalogHeader styles (kept as a separate, deliberately
// duplicated file rather than a shared component — see that component for
// the near-identical originals) so the two Product Catalog pages read as the
// same design, even though each still owns its own header actions (this one
// has no Back button, and shows a location selector instead — see
// ProductsCatalog/index.js).
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  // background: ${theme.colors.bg.primary};
  padding: 0 10px 10px;
  width: 100%;
`

export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  min-width: 0;
`

export const LogoMark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: ${theme.colors.text.primary};
  flex-shrink: 0;
`

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
`

export const Title = styled.h2`
  font-family: ${theme.fonts.heading};
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  line-height: 1.25;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subtitle = styled.p`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.secondary};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: ${theme.colors.text.muted};
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  flex-shrink: 0;
`
